import GlobalMixin from '@/app/shared/mixins/global';

export default {
    mixins: [
        GlobalMixin
    ],
    components:
    {
        Modal: () => import(/* webpackChunkName: "modal-data" */ '@/app/shared/components/modals/ModalData'),
    },
    props: {
        url: {
            type: String,
            default: ''
        },
        panelTitle: {
            type: String,
            default: ''
        },
        moduleCode: {
            type: String,
            require: true,
            default: null
        },
        closeBtn: {
            type: Boolean,
            default: true
        },
        reloadBtn: {
            type: Boolean,
            default: true
        },
        noRecords: {
            type: String,
            default: '',
        },
        hasConfirmation: {
            type: Boolean,
            default: true
        },
        eventsReload: {
            type: [String, Array],
            default: 'map.reload',
        },
        eventReloadBtn: {
            type: String,
            default: 'map.reload',
        },
        eventMapSelect: {
            type: String,
            default: 'select-feature',
        }
    },
    data() {
        return {
            idPanel: 'idPanel',
            loaded: false,
            showContent: true,
        }
    },
    computed: {
        modalTitle() {
            return this.panelTitle || this.$t(`${this.idPanel}.title`);
        },
        ctrlPanel(){
            return this.$store.getters[`${this.moduleCode}/getPanel`](this.idPanel) ?? {};
        },
        panel(){
            return this.ctrlPanel;
        },
        panelUrl(){
            return this.panel?.url ?? {};
        },
        panelAcl(){
            return this.panel?.acl ?? {};
        },
        showModal() {
            return this.panel.show;
        },
        reload() {
          return this.panel.reload;
        },
        titleTemplate() {
          return this.panel.titleTemplate;
        },
        txtNoRecords() {
            return this.$t(this.noRecords || this.panel.txtNoRecords);
        },
        translateID() {
            return `${this.idPanel}`;
        },
    },
    watch: {
        showModal (value) {
            if(value){
                this.initialize();
            }
        },
        reload (value) {
            if(value){
                if(this.loaded){
                    this.loadData();
                }
            }
        }
    },
    methods: {
        initialize: function() {
            if(this.loaded){
                return;
            }
            this.loadData();
        },
        loadData: async function() {
        },
        closeModal: function() {
            this.$store.dispatch(`${this.moduleCode}/closePanel`, this.idPanel);
            this.$emit('close');
        },
        reset() {
            this.loaded=false;
        },
        reloadData() {
            if (!this.hasConfirmation) {
                this.publishEventListen(this.moduleCode, this.eventReloadBtn);
                return;
            }

            this.$root.$emit('openConfirmation', {
                id: null,
                data: null,
                text: this.$t(`${this.idPanel}.msg.confirm.reload`),
                callback: () => {
                    this.publishEventListen(this.moduleCode, this.eventReloadBtn);
                }
            });
        },
    },
};